import { graphqlRequest, throwIfGraphQLError } from './graphqlClient.js';
import type { ShellHydration } from './hydration.js';
import type { UploadedAttachment } from './uploads.js';

export interface WidgetFeedbackInput {
  feedbackType: string;
  rating?: number;
  ratingStyle?: string;
  comment?: string;
  /** Feedback name — the event-style grouping key, not the submitter. */
  name?: string;
  /** Submitter's full name. */
  userName?: string;
  /** Submitter's email. */
  email?: string;
  metadata?: Record<string, unknown>;
  attachments?: UploadedAttachment[];
}

export async function submitWidgetFeedback(hydration: ShellHydration, input: WidgetFeedbackInput): Promise<boolean> {
  const response = await graphqlRequest<{ submitWidgetFeedback: boolean }>(hydration, {
    query: `mutation SubmitWidgetFeedback($input: SubmitWidgetFeedbackInput!) {
      submitWidgetFeedback(input: $input)
    }`,
    variables: { input: { projectId: hydration.projectId, ...input } },
    operationName: 'SubmitWidgetFeedback',
  });
  throwIfGraphQLError(response, 'widget feedback submit failed');
  return Boolean(response.data?.submitWidgetFeedback);
}
